import { canRenderSidebar, getSidebarConfig, SKINNED_SIDEBAR_CONFIGS } from '../../../config/sidebar';
import { SIDEBAR_COMPONENTS, DrawerLayout } from '../../../config/skinRegistry';
import { useLocation } from 'react-router';
import useBreakpoints from '../../../hooks/useBreakpoints';
import { useSkinConfigs } from '../../../hooks/useSkinConfigs';
import useProductAvailability from '../../../hooks/useProductAvailability';

type DrawerNavigationProps = {
  isOpen: boolean;
  isCompact?: boolean;
  toggleVisibility: (isOpen: boolean) => void;
};

const DrawerNavigation = ({ isOpen, isCompact = false, toggleVisibility }: DrawerNavigationProps) => {
  const location = useLocation();
  const { isMobile } = useBreakpoints();
  const productAvailability = useProductAvailability();
  const sidebarConfigs = useSkinConfigs(SKINNED_SIDEBAR_CONFIGS);

  const sidebarConfig = getSidebarConfig(sidebarConfigs, location.pathname, isMobile);

  if (!sidebarConfig || !canRenderSidebar(sidebarConfig, productAvailability)) return null;

  const { sidebarType } = sidebarConfig;
  const DrawerContent = SIDEBAR_COMPONENTS[sidebarType];

  return (
    <DrawerLayout isOpen={isOpen} isCompact={isCompact} toggleVisibility={toggleVisibility} sidebarType={sidebarType}>
      <DrawerContent />
    </DrawerLayout>
  );
};

export default DrawerNavigation;
